const DurationIcon = () => (
  <svg aria-label="Duration Icon" role="img" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg">
    <g id="Metrics/Duration">
      <path
        id="fill"
        d="M7.99967 2.90909C11.6816 2.90909 14.6663 5.83959 14.6663 9.45455C14.6663 13.0695 11.6816 16 7.99967 16C4.31778 16 1.33301 13.0695 1.33301 9.45455C1.33301 5.83959 4.31778 2.90909 7.99967 2.90909ZM7.99967 4.36364V9.45455H13.1849C13.1849 6.64291 10.8634 4.36364 7.99967 4.36364ZM13.9256 1.45455C14.3347 1.45455 14.6663 1.78016 14.6663 2.18182C14.6663 2.58348 14.3347 2.90909 13.9256 2.90909C13.5165 2.90909 13.1849 2.58348 13.1849 2.18182C13.1849 1.78016 13.5165 1.45455 13.9256 1.45455ZM10.2219 0V1.45455H5.77745V0H10.2219Z"
      />
    </g>
  </svg>
);

export default DurationIcon;
